// Strip Microsoft Office / Google Sheets noise from clipboard HTML before
// running it through Plate's HTML deserializer. Office variants leak:
//   - <!--[if ...]>...<![endif]--> conditional comments
//   - <!--td { ... } br { ... }--> CSS-in-comments (this is the bit that
//     was rendering as literal text inside the editor)
//   - <o:*>, <w:*>, <m:*>, <v:*>, <x:*> namespaced tags
//   - mso-* inline CSS properties + class="MsoNormal" / xmlns:* attrs
//   - <style> blocks at the top of the fragment
//   - smart-tag <st1:*> wrappers
//
// We also strip every `font-family: ...;` and `<font face=...>` attribute
// so pasted content always renders in the editor's default Gilroy stack —
// otherwise pasting from Word / Docs drops "Calibri" / "Arial" inline
// styles into our document and the editor becomes a font Frankenstein.
// font-size + color stay, only font-family is normalised away.
//
// We do this purely textually, BEFORE handing the string to DOMParser, so
// the parser never sees the garbage to begin with.

export function sanitizeOfficeHtml(html: string): string {
    return (
        html
            .replace(/<!--[\s\S]*?-->/g, '')
            .replace(/<\?xml[^>]*\?>/gi, '')
            .replace(/<\/?(?:o|w|m|v|x|st\d):[^>]+>/gi, '')
            .replace(/<style[\s\S]*?<\/style>/gi, '')
            .replace(/\sclass="Mso[^"]*"/gi, '')
            .replace(/\smso-[a-z-]+:[^;"']*;?/gi, '')
            .replace(/\sxmlns(?::[a-z]+)?="[^"]*"/gi, '')
            // Strip font-family from inline `style="..."` (matches with or
            // without leading semicolon / quotes around the value).
            .replace(/font-family\s*:\s*[^;"']*;?/gi, '')
            // Strip the legacy <font face="..."> attribute.
            .replace(/\sface\s*=\s*"[^"]*"/gi, '')
            .replace(/\sface\s*=\s*'[^']*'/gi, '')
    );
}
